import React, { useCallback, useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { getMyCompaniesListQuery } from 'src/apis/company';
import { debounce } from 'lodash';
import Select from 'react-select';

function CompanySelectionWithId({
	selectedCompany,
	onChange,
}: {
	selectedCompany?: { label: string; value: string };
	onChange: (value: { label: string; value: string; logo: string; url: string } | null) => void;
}) {
	const [typedCompanyName, setTypedCompanyName] = useState('');
	const [debouncedCompanyName, setDebouncedCompanyName] = useState('');

	const { data: companiesData, isLoading } = useQuery(
		['companiesWithId', debouncedCompanyName],
		() => getMyCompaniesListQuery(debouncedCompanyName),
		{
			staleTime: 60 * 1000,
		},
	);

	const items = useMemo(() => {
		const items = [];
		const companies =
			companiesData?.companies?.map(c => ({ label: c.name, value: c._id, logo: c?.logo, url: c?.url })) || [];
		items.push(...companies);
		return items;
	}, [companiesData?.companies]);

	const debouncedSetCompanyName = useCallback(
		debounce((value: string) => {
			setDebouncedCompanyName(value);
		}, 300),
		[],
	);

	return (
		<div>
			<Select
				required
				options={items}
				menuPosition="fixed"
				isLoading={isLoading}
				menuPlacement={'auto'}
				value={selectedCompany}
				classNamePrefix="flowbite-select"
				inputValue={typedCompanyName}
				onInputChange={value => {
					setTypedCompanyName(value);
					if (value) {
						debouncedSetCompanyName(value);
					}
				}}
				onChange={selection =>
					onChange(selection as { label: string; value: string; logo: string; url: string } | null)
				}
			/>
		</div>
	);
}

export default CompanySelectionWithId;
